<template>
  <div>
    <div class="action-buttons">
      <Button
        :label="t('Atualizar')"
        icon="pi pi-refresh"
        data-testid="fiscal-config-btn-refresh"
        @click="loadData" />
    </div>

    <fiscal-config-table
      ref="tableRef"
      :rows="rows"
      :loading="isLoading"
      @edit="handleEdit" />

    <!-- FiscalConfigModal is centralized in ModalManager.vue -->
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import FiscalConfigTable from './FiscalConfigTable.vue';
import { eventBus } from '../../../eventBus';
import { log } from '../../../utils/DebugLogger';
import { usePaymentInvoices } from '../../../composables/usePaymentInvoices';

const { t } = useI18n();
const { listFiscalConfigs } = usePaymentInvoices();

type Row = {
  franchise_id: number;
  franchise_name: string;
  country: string | null;
  invoice_provider: string | null;
  is_configured: boolean;
};

const rows = ref<Row[]>([]);
const isLoading = ref<boolean>(false);
const tableRef = ref<{ loadData: () => void } | null>(null);

const loadData = async (): Promise<void> => {
  log('FiscalConfigPage', 'loadData', 'Fetching fiscal config rows');
  isLoading.value = true;
  try {
    rows.value = await listFiscalConfigs();
  } finally {
    isLoading.value = false;
  }
};

const handleEdit = (franchiseId: number): void => {
  log('FiscalConfigPage', 'handleEdit', 'Opening modal', franchiseId);
  eventBus.emit('modal.fiscal-config.open', { franchiseId });
};

const handleUpdated = (): void => {
  log('FiscalConfigPage', 'event:fiscal-config.updated', 'Refreshing table');
  loadData();
};

onMounted(() => {
  log('FiscalConfigPage', 'mounted', 'Mounted');
  loadData();
  eventBus.on('fiscal-config.updated', handleUpdated);
});

onBeforeUnmount(() => {
  eventBus.off('fiscal-config.updated', handleUpdated);
});

defineExpose({ loadData });
</script>

<style scoped>
.action-buttons {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}
</style>
